import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslate } from "ra-core";
import { useDeleteFileSystemNodeDialog } from "../dialogs/delete-file-system-node-dialog/DeleteFileSystemNodeDialogProvider";

const DeleteFileSystemNodeButton = (props) => {
    const { onClick, fileSystemNodePath } = props;
    const translate = useTranslate();
    const dialog = useDeleteFileSystemNodeDialog();
    const handleOnClick = () => {
        dialog.open(fileSystemNodePath);
        onClick();
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <DeleteIcon/>
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.delete`)} />
        </ListItem>
    ) 
};
export default DeleteFileSystemNodeButton;
